import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './services/auth.service';
import {map} from 'rxjs/operators';

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    // return this.checkLogin(url);
    return this.authService.isAuthenticated
      .pipe(
        map(response => {
          console.log('response:', response);

          if (!response) {
            setTimeout(() => {
              window.location.href = '#!/login';
            });
            return false;
          }
          return true;
        })
      );

  }


  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    // this.router.navigate(['/login']);
    window.location.href = '#!/login';
    return false;
  }
}
